import { useRoutes } from 'react-router';

const AppRoutes = () => {
	const routeMap = [ ];
	return useRoutes(routeMap);
};

export default AppRoutes;
